import { __assign } from "tslib";
// DS: C109
import React, { useContext, useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '../../types/resource';
import { Section } from '../../a11y/headings/tagWrappers';
import Heading from '../../a11y/headings/Heading';
import DeviationDuperbrowseContext from '../../Duperbrowse/DeviationDuperbrowseContext';
import { DeviationTypes } from '../../types/deviation';
import { dateToDistanceTrans } from '../../Timestamp/functions';
import { getDeviationType } from '../../DeviationViews/_helpers';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import UserAvatar from '../../User/Avatar/UserAvatar';
import UserLinkWithTooltip from '../../User/Link/UserLinkWithTooltip';
import Flex from '../../Flex';
import shortenNumber from '../../utils/shortenNumber';
import GhostButton from '../../Buttons/GhostButton';
import Slider from '../../Slider';
import UserWatchGhostButton from '../UserWatchGhostButton';
import s from './UserSampleGallery.scss';
var DESKTOP_THUMB_DIMS = { width: 163, height: 110 };
var MOBILE_THUMB_DIMS = { width: 117, height: 78 };
var BI_SECTIONNAME = 'watch_suggestions';
/** Gruser blurb, watch button, and small row of their deviations */
export var UserSampleGallery = function (_a) {
    var user = _a.user, isOwnUser = _a.isOwnUser, dataHook = _a.dataHook, deviations = _a.deviations, duperbrowseContextTitle = _a.duperbrowseContextTitle, onWatch = _a.onWatch, className = _a.className;
    var profile = user.profile, stats = user.stats, details = user.details, _b = user.type, userType = _b === void 0 ? '' : _b, useridUuid = user.useridUuid, userId = user.userId;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    // fire a bi event on the mobile gallery when scrolled, but only once
    var biData = useMemo(function () { return ({
        typeid: ResourceType.USER,
        itemid: userId,
    }); }, [userId]);
    // build a limited gallery of deviations wrapped in duperbrowse
    var thumbs = deviations && (React.createElement(DeviationDuperbrowseContext, { streamId: "UserSampleGallery-" + useridUuid, deviations: deviations, parent: { title: duperbrowseContextTitle } }, deviations.map(function (deviation, idx) { return (React.createElement(BiLoggerContextProvider, { key: "thumb-" + idx, value: { rank: idx } },
        React.createElement(DeviationLink, { deviation: deviation, className: s['thumb-link'] },
            React.createElement(DeviationDumbView, __assign({ deviation: deviation }, (isMobile ? MOBILE_THUMB_DIMS : DESKTOP_THUMB_DIMS), (getDeviationType(deviation) ===
                DeviationTypes.LITERATURE && {
                className: s['literature-thumb'],
                coverLetterClassName: s['literature-thumb-cover-letter'],
            })))))); })));
    var isGroup = userType.includes('group');
    var tagline = (profile === null || profile === void 0 ? void 0 : profile.tagline) || '';
    var allow2LineName = !tagline && !isMobile;
    var joinedDistance = details && dateToDistanceTrans(details.joindate);
    var joinedDistanceLocaleKey = isMobile
        ? 'watchSuggestionsV2.userSampleGallery.joinedDateDistance.mobile'
        : 'watchSuggestionsV2.userSampleGallery.joinedDateDistance';
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: BI_SECTIONNAME } },
        React.createElement(Section, { className: classnames(s['root'], isGroup && s['is-group'], className), "data-hook": dataHook },
            React.createElement("div", { className: s['content'] },
                React.createElement(UserAvatar, { user: user, size: isMobile ? 32 : 50, className: classnames(s['avatar'], user.usericonDefault && s['avatar-default']) }),
                React.createElement("div", { className: s['user-info'] },
                    React.createElement(Heading, { className: s['user-link-heading'] },
                        React.createElement(UserLinkWithTooltip, { user: user, withTooltip: true, className: allow2LineName ? s['user-link-2-line'] : s['user-link'] })),
                    tagline && React.createElement("span", { className: s['tagline'] }, tagline),
                    React.createElement("div", { className: s['stats'] },
                        stats && (React.createElement("span", { className: s['stat-item'] },
                            shortenNumber(stats.watchers, 0),
                            ' ',
                            t('watchSuggestionsV2.userSampleGallery.watchers', {
                                formattedCount: stats.watchers,
                                count: stats.watchers,
                            }))),
                        joinedDistance && (React.createElement("span", { className: s['stat-item'] }, t(joinedDistanceLocaleKey, {
                            distance: t(joinedDistance.key, {
                                count: joinedDistance.value,
                            }),
                        })))),
                    React.createElement(Flex, { className: s['watch-join-buttons'] },
                        !isOwnUser && (React.createElement(UserWatchGhostButton, { author: user, className: s['watch-button'], onWatch: onWatch })),
                        isGroup && (React.createElement(GhostButton, { className: s['join-button'], size: "small", variant: "approval-green", href: Url.userLink(user.username), "aria-hidden": true }, t('common.join')))))),
            isMobile ? (React.createElement(Slider, { className: s['gallery'], slimSpacing: true, onScrollBiData: biData }, thumbs)) : (React.createElement(Flex, { className: s['gallery'] }, thumbs)))));
};
UserSampleGallery.displayName = 'UserSampleGallery';
export default UserSampleGallery;
//# sourceMappingURL=UserSampleGallery.js.map